import * as S from './styles';
import { MdOutlineCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function CheckBox({ marked = false, ...rest}) {

    return (
        <S.CheckboxContainer checked={marked} {...rest} >
            <S.HiddenCheckbox checked={marked} />
            {marked ?
                (
                    <MdOutlineCheckBox size="35px" color="#00a2e0" />
                ) : (
                    <MdOutlineCheckBoxOutlineBlank size="35px" color="#00a2e0" />
                )
            }
        </S.CheckboxContainer>
    );
}
